import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';
import { removeWhiteSpaces } from '@/helpers/StringHelpers';
import { telephoneNumberInternationlFormat } from '@/helpers/TelephoneHelpers';

export default class isTelephoneAvailable {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService;

    /**
     * LegacyIsTelephoneAvailable constructor.
     *
     * @returns {void}
     */
    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_API_URL);
    }

    /**
     * Check if requested telephone is available.
     *
     * @param {String} telephone
     *
     * @returns {Promise}
     */
    handle(telephone) {
        // Telephone number must be international format for api.
        let formattedTelephone = telephoneNumberInternationlFormat(telephone);

        // Remove white spaces since api database doesn't store telephone numbers with white spaces.
        formattedTelephone = removeWhiteSpaces(formattedTelephone);

        return this.apiService
            .post(ApiEndpoints['users.validate.telephone'], {
                telephone: formattedTelephone,
            });
    }
}
